import type { AxiosResponse } from "axios";

import { downloadFile } from "../../utils";
import api from "../../../../../api";
import type { CommandFormValues } from "../../types";
import { exportEURTransactionsRequestSchema } from "./types";
import type { IUser } from "../../../../../types";
import { validateValues } from "../../utils";

export const handleEURTransactions = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { date, fileType, elsterField } = validateValues(
    values,
    exportEURTransactionsRequestSchema
  );

  const response = await api.kontax.exportEURTransactions(
    user.id,
    date,
    fileType,
    elsterField
  );

  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });

  const downloadUrl = window.URL.createObjectURL(blob);
  const fileName =
    response.headers["content-disposition"]?.split("filename=")[1] ||
    `EUR_${elsterField}_${date.year()}.${fileType}`;

  downloadFile(downloadUrl, fileName);
  // Revoke the object URL to avoid memory leaks.
  window.URL.revokeObjectURL(downloadUrl);

  return response;
};
